import React from 'react';
import cn from 'classnames';

import CourseDefaultPreviewBase from 'assets/img/course-preview.svg';

import styles from './CoursePreview.module.scss';

const CourseDefaultPreview =
  CourseDefaultPreviewBase as unknown as React.ComponentType<{
    className?: string;
  }>;

const CoursePreview = ({
  className,
  preview,
}: {
  className: any;
  preview: any;
}) =>
  preview ? (
    <img className={cn(styles.preview, className)} src={preview} />
  ) : (
    <CourseDefaultPreview className={cn(styles.preview, className)} />
  );

export default React.memo(CoursePreview) as any;
